import { Component as BaseComponent, h } from 'preact';
import { connect } from 'preact-redux';

class Component extends BaseComponent {
    render({logged_in, state_upc, sale_price_code, coins, price, percent, upc}) {
        let className = 'row container';
        if (state_upc == upc) className += ' selected';

        let ga_label = 'logged-out';
        if (logged_in) {
            ga_label = sale_price_code == 'first-time-buyer' ? '1st-kc-package' : '2nd-or-more-kc-package';
        }

        return (
            <standard-package class={className}>
                <label>
                    <div class='small-2 columns'>
                        <input
                          type='radio'
                          name='upc'
                          value={upc}
                          checked={state_upc == upc}
                          onChange={() => this.trackChange(upc, ga_label)}
                        />
                        <div class='pseudo-radio' />
                    </div>
                    <div class='small-1 columns'>
                        <div class='icon-teeup icon-karma-coin' />
                    </div>
                    <div class='small-6 columns'>
                        <h4>
                            {coins} <span>Karma Coins</span>
                        </h4>
                        <h6>${price}</h6>
                    </div>
                    <div class='small-3 columns'>
                        {this.renderDiscountAmount(percent)}
                    </div>
                </label>
            </standard-package>
        );
    }

    renderDiscountAmount(percent) {
        if (parseInt(percent, 10) > 0) {
            return (
                <h5>
                    <b>{percent}</b>
                    <br />
                    OFF
                </h5>
            );
        }

        return null;
    }

    trackChange(upc, ga_label) {
        this.props.trackChange(upc, ga_label);
        this.props.setUPC(upc);
    }
}

const mapStateToProps = (state) => ({
    logged_in: state.user && state.user.logged_in,
    state_upc: state['karmacoin-store'] && state['karmacoin-store'].upc,
    sale_price_code: state['karmacoin-store'].packages && state['karmacoin-store'].packages.standard[0].sale_price_code,
});

const mapDispatchToProps = (dispatch) => ({
    trackChange: (upc, ga_label) => dispatch({ type: 'ga:event', payload: [ 'kc-store', 'Click-' + upc, ga_label ] }),
    setUPC: (upc) => dispatch({ type: 'karmacoin-store:upc', payload: upc }),
});

export default connect(mapStateToProps, mapDispatchToProps)(Component);



// WEBPACK FOOTER //
// ./app/components/karmacoin-store/standard-package.js